(function (window) {
  'use strict';
  const programSelect = document.getElementById('ambassadors-program');
  // Shows/hides additional form options related to the selected Program option.
  function handleInquiryChange(e) {
    const newValue = e.target.value;
    const optionContainers = document.querySelectorAll('.ambassadors__additional-options');
    for (let i = 0; i < optionContainers.length; i++) {
      const optionContainer = optionContainers[i];
      if (newValue === optionContainer.getAttribute('data-options-id')) {
        optionContainer.setAttribute('aria-hidden', false);
      }
      else {
        optionContainer.setAttribute('aria-hidden', true);
      }
    }
  }
  if (programSelect) {
    programSelect.addEventListener('change', handleInquiryChange);
  }
})(this);
